const websiteVersion = process.env.NODE_ENV === 'development' ? '' : '006d010'

export default websiteVersion
